import { OccasionType } from '../../src/lib/graphql';

export function isInMemoryOccasion(
  occasionType: OccasionType | undefined,
): boolean {
  return occasionType === 'IN_MEMORY';
}
